import GraphModel from "@/src/model/GraphModel";
export default class WorkspaceModel {
    parent: WorkspaceModel | null;
    children: (GraphModel | WorkspaceModel)[] = [];
    label: string;
    leaf: boolean = false;
    key: number;
    selectable: boolean = false;

    constructor(parent: WorkspaceModel | null = null, data: object, graphMap: Map<number, GraphModel>) {
        this.parent = parent;
        this.label = data.name
        this.key = data.id
        // create all properties from data
        for (const [key, value] of Object.entries(data)) {
            if (key !== 'children' && key !== 'parent') {
                this[key] = value;
            }
        }

        for (const child of data['children'] || []) {
            let el
            if (child.hasOwnProperty('workspace_id')) {
                el = new GraphModel(this, child)
                graphMap.set(el.id, el)
            } else {
               el = new WorkspaceModel(this, child, graphMap)
            }
            this.children.push(el);
        }

    }
}